import React from "react";
import { Settings, Menu } from "lucide-react";
import { useT } from "../../../stores/uiLang";

// Run E2 J2: teacher dashboard header in English and Spanish.
const HDR_T = {
  en: {
    title: "Instructor Dashboard",
    sub: "Easily track student progress, customize grading, and manage assessments.",
    settings: "Settings",
    openMenu: "Open navigation menu",
  },
  es: {
    title: "Panel del maestro",
    sub: "Sigue el progreso de tus estudiantes, ajusta las calificaciones y administra las evaluaciones.",
    settings: "Configuración",
    openMenu: "Abrir el menú de navegación",
  },
};

interface DashboardHeaderProps {
  readonly onOpenSettings: () => void;
  readonly onToggleMobileMenu?: () => void;
}

export function DashboardHeader({
  onOpenSettings,
  onToggleMobileMenu,
}: DashboardHeaderProps) {
  const t = useT(HDR_T);
  return (
    <div className="bg-white py-6 px-4 shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {/* Mobile hamburger menu */}
            {onToggleMobileMenu && (
              <button
                onClick={onToggleMobileMenu}
                className="md:hidden p-2 -ml-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg"
                aria-label={t.openMenu}
              >
                <Menu className="h-6 w-6" />
              </button>
            )}
            <div className="min-w-0">
              <h1 className="text-xl font-bold text-gray-900 sm:text-2xl truncate">
                {t.title}
              </h1>
              <p className="hidden sm:block mt-1 text-sm text-gray-600">
                {t.sub}
              </p>
            </div>
          </div>
          <div className="flex-shrink-0">
            <button
              onClick={onOpenSettings}
              className="btn btn-small btn-secondary"
            >
              <Settings className="-ml-1 sm:mr-2 h-5 w-5 text-[var(--color-btnSecondaryText)] mr-0" />
              <span className="hidden sm:inline">{t.settings}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
